export function VideoRecordingDetailLoadingPlaceholder() {
  return (
    <div className="">
      <div className="placeholder-glow">
        <div
          className="placeholder list-group-item px-0 bg-dark rounded-1"
          style={{ width: '100%', aspectRatio: '16/9' }}
        >
          <div className=" col-6"></div>
        </div>
      </div>
      <div className="placeholder-glow mt-2">
        <div className="placeholder" style={{ width: '100px', height: '40px' }}></div>
      </div>
      <div className="placeholder-glow mt-2">
        <div className="placeholder" style={{ width: '300px' }}></div>
      </div>
    </div>
  );
}
